var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgDropdown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20px",
  height: "20px",
  viewBox: "0 0 18 18",
  fill: "#BECCD8",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.946 6.278A.804.804 0 0 0 3.8 6.42a.97.97 0 0 0-.081 1.057l.068.104.08.092 5.132 5.183 5.13-5.176.055-.061a.99.99 0 0 0 .147-.98l-.057-.114-.067-.098-.045-.054-.091-.083a.804.804 0 0 0-.907-.088l-.101.069-.083.074-3.906 3.9-.217-.03-3.826-3.862-.085-.076Z",
  fillRule: "evenodd"
})));

export default SvgDropdown;